import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "offer-list-item d-flex align-center" }
const _hoisted_2 = { class: "text-wrap flex-grow-1" }


import { Partner } from "@emblem/api";
import MarkdownViewer from "./MarkdownViewer.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'OffersList',
  props: {
    offers: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    rounded: "",
    class: "overflow-hidden"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_list, {
        class: "py-0",
        "bg-color": "grey-lighten-3"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.offers, (offer, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: offer.id
            }, [
              _createVNode(_component_v_list_item, {
                class: _normalizeClass({
            'pa-2': true,
            'text-disabled': offer.type === 'gift' && offer.reclaimed,
          })
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, _toDisplayString(offer.summary), 1),
                    (offer.description)
                      ? (_openBlock(), _createBlock(_component_v_btn, {
                          key: 0,
                          size: "small",
                          variant: "plain",
                          "min-width": "0",
                          class: "px-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, { icon: "fa-regular fa-circle-question" }),
                            _createVNode(_component_v_dialog, { activator: "parent" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  width: "400px",
                                  "max-width": "80vw",
                                  "max-height": "80vh"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_card_text, null, {
                                      default: _withCtx(() => [
                                        _createVNode(MarkdownViewer, {
                                          content: offer.description
                                        }, null, 8, ["content"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    (offer.type == 'gift')
                      ? (_openBlock(), _createBlock(_component_v_checkbox, {
                          key: 1,
                          modelValue: offer.reclaimed,
                          "onUpdate:modelValue": ($event: any) => ((offer.reclaimed) = $event),
                          class: "ml-1 flex-grow-0",
                          "hide-details": "",
                          "true-icon": "fas fa-circle-check",
                          "false-icon": "fa-regular fa-circle",
                          density: "compact"
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                      : _createCommentVNode("", true),
                    (offer.flash)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 2,
                          class: "ml-2",
                          color: "primary",
                          icon: "fas fa-bolt"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 2
              }, 1032, ["class"]),
              (i < __props.offers.length - 1)
                ? (_openBlock(), _createBlock(_component_v_divider, { key: 0 }))
                : _createCommentVNode("", true)
            ], 64))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})